import { createFileRoute } from '@tanstack/react-router'
import StudentAssessment from '@/pages/candidate-assessment'

export const Route = createFileRoute(
  '/_authenticated/assessments/$assessmentsId'
)({
  component: StudentAssessment,
})
